module.exports = {
	"actionUrl": "https://docs.google.com/forms/d/e/1FAIpQLScxat2bN8XxQyp72H0ibmkm-5FtzFCNUeBw1DA8xdpA5N5-6Q/formResponse",
	"fields": {
		"Round": "entry.1689460968",
		"Player 1": "entry.1586728669",
		"Player 2": "entry.1665835053",
		"Player 1 Set 1": "entry.151139836",
		"Player 2 Set 1": "entry.1657562388",
		"Player 1 Set 2": "entry.803176882",
		"Player 2 Set 2": "entry.1338830378",
		"Player 1 Set 3": "entry.1673548937",
		"Player 2 Set 3": "entry.553799335"
	}
};


//////////////////
// WEBPACK FOOTER
// ./formDetails/matches.json
// module id = 26
// module chunks = 0